import { useNavigate } from 'react-router-dom'
import { RiShoppingBag3Line } from 'react-icons/ri'
import { useOrders } from '@/api/useOrders'
import { OrderStatusBadge } from '@/components/orders/OrderStatusBadge/OrderStatusBadge'
import { OrderProgressBar } from '@/components/orders/OrderProgressBar'
import { Button, Spinner } from '@/components/ui'
import { ROUTES, buildRoute } from '@/constants/routes'
import styles from './OrdersList.module.css'

const ACTIVE_STATUSES = ['pending', 'confirmed', 'printing', 'shipped']

export function OrdersList() {
    const navigate = useNavigate()
    const { data: orders, isLoading } = useOrders()

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.loading}>
                    <Spinner size="lg" />
                </div>
            </div>
        )
    }

    const activeOrder = orders?.find((o) => ACTIVE_STATUSES.includes(o.status))

    return (
        <div className={styles.container}>
            <div className={styles.pageHeader}>
                <h1 className={styles.title}>Mis Pedidos</h1>
                <p className={styles.subtitle}>
                    {orders && orders.length > 0
                        ? `${orders.length} pedido${orders.length !== 1 ? 's' : ''} realizados`
                        : 'Aquí verás el historial de tus pedidos'}
                </p>
            </div>

            {activeOrder && (
                <div
                    className={styles.activeBanner}
                    onClick={() => navigate(buildRoute.orderDetail(activeOrder.uuid))}
                >
                    <div className={styles.bannerHeader}>
                        <span className={styles.bannerTitle}>Tu pedido en proceso</span>
                        <span className={styles.bannerOrderNum}>{activeOrder.order_number}</span>
                    </div>
                    <OrderProgressBar status={activeOrder.status} compact />
                    <div className={styles.bannerMeta}>
                        <span>
                            {activeOrder.item_count} producto{activeOrder.item_count !== 1 ? 's' : ''} · S/ {activeOrder.total}
                        </span>
                        <span className={styles.bannerLink}>Ver detalles →</span>
                    </div>
                </div>
            )}

            {!orders || orders.length === 0 ? (
                <div className={styles.empty}>
                    <div className={styles.emptyIcon}>
                        <RiShoppingBag3Line />
                    </div>
                    <h3 className={styles.emptyTitle}>Sin pedidos aún</h3>
                    <p className={styles.emptyDesc}>
                        Cuando realices un pedido de impresión, aparecerá aquí. Puedes hacer seguimiento del estado de cada pedido.
                    </p>
                    <Button variant="primary" onClick={() => navigate(ROUTES.projects)}>
                        Ir a mis proyectos
                    </Button>
                </div>
            ) : (
                <div className={styles.list}>
                    {orders.map((order) => (
                        <div
                            key={order.uuid}
                            className={styles.card}
                            onClick={() => navigate(buildRoute.orderDetail(order.uuid))}
                        >
                            <div className={styles.cardHeader}>
                                <span className={styles.orderNumber}>{order.order_number}</span>
                                <OrderStatusBadge status={order.status} />
                            </div>
                            <div className={styles.cardBody}>
                                <p>
                                    {order.first_project_name}
                                    {order.item_count > 1 && (
                                        <span className={styles.moreItems}> y {order.item_count - 1} más</span>
                                    )}
                                </p>
                                {order.item_count > 1 && (
                                    <p className={styles.meta}>
                                        {order.item_count} productos
                                    </p>
                                )}
                            </div>
                            <div className={styles.cardFooter}>
                                <span className={styles.total}>S/ {order.total}</span>
                                <span className={styles.date}>
                                    {new Date(order.created).toLocaleDateString('es-PE')}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
